import { render, staticRenderFns } from "./ExerciseLibrary.vue?vue&type=template&id=18433048&scoped=true"
import script from "./ExerciseLibrary.vue?vue&type=script&lang=js"
export * from "./ExerciseLibrary.vue?vue&type=script&lang=js"
import style0 from "./ExerciseLibrary.vue?vue&type=style&index=0&id=18433048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18433048",
  null
  
)

export default component.exports